<script lang="ts">
	import { format } from '../../../../services/i18n';
	import { onMount, createEventDispatcher } from 'svelte';
	import { getImagesByType, getImages } from '../../../Lists/list-helpers';

	import { Text, Input, Loader, Container } from '@Shelly/shelly-design-system';

	import ImageList from '../../../Lists/ImageList.svelte';
	import { capFirstChar } from '../../../../helpers/utilities';

	const dispatch = createEventDispatcher();

	export let editGroup;

	let inputRef: HTMLElement;

	let uploadedImagesDB = [];
	let imagesByGroupType = [];

	//#region Name Input functions

	const onInputName = (event: InputEvent) => {
		const target = event.target as HTMLInputElement;
		editGroup = {
			...editGroup,
			name: target.value,
		};
	};

	//#endregion Name Input functions

	//#region Images functions

	const onSelectImage = (e: CustomEvent) => {
		editGroup = {
			...editGroup,
			image: e.detail.image,
			backgroundColor: e.detail.backgroundColor,
		};
	};

	const onUploadImage = (e: CustomEvent) => {
		onSelectImage(e);
		uploadedImagesDB = [...e.detail.uploadedImagesDB];
	};

	const downloadImages = async () => {
		uploadedImagesDB = await getImages('group');
		imagesByGroupType = getImagesByType('group', null);
		return uploadedImagesDB;
	};

	//#endregion Images functions
</script>

<Container noScroll padding="0">
	<Text element="h2" class="mb-s">
		{capFirstChar(
			$format('placeholder_name', {
				values: { type: $format('process_group') },
			}),
		)}
	</Text>
	<Input
		aria-labelledby="input-7n9ohuo"
		icon="fas fa-network-wired"
		label={$format('label_name', { default: 'name' })}
		value={editGroup.name}
		error={editGroup.name === ''
			? $format('input_error_empty_name', { default: 'Name cannot be empty' })
			: ''}
		bind:ref={inputRef}
		on:input={onInputName}
		on:enter={() => dispatch('enter')}
		id="input-7n9ohuo"
	/>
</Container>

<hr class="mt-l mb-l" />

<Container noScroll padding="0">
	<Text element="h2" class="mb-m">
		{$format('select_picture', { default: 'Select Picture' })}
	</Text>

	{#await downloadImages()}
		<div class="d-flex justify-content-center">
			<Loader />
		</div>
	{:then}
		<ImageList
			{uploadedImagesDB}
			imagesByTypeDB={imagesByGroupType}
			selectedImage={editGroup.image}
			selectedBackgroundColor={editGroup.backgroundColor}
			requestType={'group'}
			on:select-image={onSelectImage}
			on:upload-image={onUploadImage}
		/>
	{/await}
</Container>
